<template>
  <div>
    <div v-if="loading" class="text-xs-center my-4">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <template v-else>
      <v-layout>
        <v-flex class="title primary--text my-2"><slot name="header"></slot> </v-flex>
        <v-flex class="text-xs-right"
          ><v-btn depressed color="primary" @click="exportData">{{ $t('export') }}</v-btn></v-flex
        >
      </v-layout>

      <template v-for="(el, index) in data">
        <table :key="index" class="zw-table fullwidth strip border-radius outline mb-4">
          <thead>
            <tr class="grey lighten-3">
              <td></td>
              <template v-if="el.total >= 0">
                <td class="text-xs-center" colspan="2">ชิ้น</td>
              </template>
              <template v-else>
                <td class="text-xs-center">
                  ขวดเล็ก ({{ index != 'phytoshot' ? '150' : '50' }} ml.)
                </td>
                <td v-if="el.big >= 0" class="text-xs-center">ขวดใหญ่ (270 ml.)</td>
              </template>
              <td class="text-xs-center">รวม (ขวด)</td>
            </tr>
          </thead>

          <tr>
            <td style="width: 30%">{{ index }}</td>
            <template v-if="el.total >= 0">
              <td colspan="2" class="text-xs-center" style="width: 35%">{{ el.total }}</td>
              <td class="text-xs-center" style="width: 35%">{{ el.total }}</td>
            </template>
            <template v-else>
              <td class="text-xs-center" style="width: 17%">{{ el.small }}</td>
              <td v-if="el.big >= 0" class="text-xs-center" style="width: 18%">
                {{ el.big }}
              </td>
              <td class="text-xs-center" style="width: 35%">{{ el.small + (el.big || 0) }}</td>
            </template>
          </tr>
        </table>
      </template>
    </template>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { mapGetters } from 'vuex'

import api from '@/api'
export default {
  props: ['date', 'value', 'loading'],
  data() {
    return {
      data: {},
      datemodal: false
      // loading: true
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    value(newVal) {
      this.data = newVal
    }
    // async date(newVal, oldVal) {
    //   if (newVal != oldVal) {
    //     this.loading = true
    //     try {
    //       var response = await this.get_nvbb_product_amount_by_date()
    //       if (response.responsecode == 200) {
    //       }
    //       this.data = response.data
    //     } catch (error) {
    //       console.log(error)
    //     }
    //     this.loading = false
    //   }
    // }
  },
  async mounted() {
    this.data = this.value
    // this.loading = true
    // try {
    //   var response = await this.get_nvbb_product_amount_by_date()
    //   if (response.responsecode == 200) {
    //   }
    //   this.data = response.data
    // } catch (error) {
    //   console.log(error)
    // }
    // this.loading = false
  },
  methods: {
    exportData() {
      let data = []
      for (const key in this.data) {
        if (Object.hasOwnProperty.call(this.data, key)) {
          const el = this.data[key]
          if (el.total >= 0) {
            data.push(['', 'ชิ้น', 'รวม(ขวด)'])
          } else if (key == 'phytoshot') {
            data.push(['', 'ขวดเล็ก (50 ml.)', 'รวม(ขวด)'])
          } else {
            data.push(['', 'ขวดเล็ก (150 ml.)', 'ขวดใหญ่ (270 ml.)', 'รวม(ขวด)'])
          }

          if (el.total >= 0) {
            data.push([key, el.total, el.total])
          } else if (key == 'phytoshot') {
            data.push([key, el.small, el.small])
          } else {
            data.push([key, el.small, el.big, el.small + el.big])
          }

          data.push([''])
        }
      }
      // var json = this.value

      const dataWS = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, `summary-drink-${this.date}.xlsx`)
    },
    async changeDate() {
      this.loading = true
      try {
        var response = await this.get_nvbb_product_amount_by_date()
        if (response.responsecode == 200) {
        }
        this.data = response.data
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    get_nvbb_product_amount_by_date() {
      var data = {
        pageid: this.selectedBot.pageid,
        tab: 'all',
        date: this.date
      }
      return new Promise((resolve, reject) => {
        api.get_nvbb_product_amount_by_date(data, (error, response) => {
          if (error) {
            reject(error)
          }

          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/NvbbSummaryDrinkDetail.vue